
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Thanetopunecab() {



    const cardData =
    {
        keyword: ' Thane to Pune Cab',
        heading: 'Skyline Cabs: Thane to Pune Cab ',
        headingDescription: 'Skyline Cabs offers trusted and hassle-free Thane to Pune Cab service for a smooth intercity travel experience. Whether you are commuting for work, planning a family visit, or escaping for a weekend trip, our fleet of clean, comfortable vehicles and professional drivers ensures a safe and pleasant journey. With punctual pickups from Thane, transparent fares, and 24/7 customer support, Skyline Cabs is your go-to travel partner. Book your Thane to Pune cab today and travel with ease and confidence.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
  {
    "name": "Thane to Pune Cab",
    "description": "Skyline Cabs offers reliable and affordable taxi services from Thane to Pune. We provide a variety of vehicles to suit your needs, including Innova, Ertiga, and sedans. Whether you’re traveling for business or leisure, you can expect a comfortable and safe journey with transparent pricing and well-maintained vehicles."
  },
  {
    "name": "Thane to Pune Taxi",
    "description": "Skyline Cabs provides dependable and punctual taxi services from Thane to Pune. With our fleet of comfortable cars and experienced drivers, you can enjoy a smooth and stress-free ride. Book your taxi now for a hassle-free journey at affordable rates."
  },
  {
    "name": "Thane to Pune Station Cab Fare",
    "description": "Looking for a taxi from Thane to Pune Station? Skyline Cabs offers competitive fares for this route, ensuring you get the best value for your trip. With a fleet of well-maintained vehicles, we guarantee a comfortable and timely ride with no hidden charges."
  },
  {
    "name": "Thane to Pune One Way Cab",
    "description": "Skyline Cabs offers affordable one-way cab services from Thane to Pune. Our one-way taxis are the perfect solution for those looking for a direct, economical journey without the hassle of round-trip booking. Choose from a variety of vehicles and enjoy a comfortable ride."
  },
  {
    "name": "Thane to Pune Ertiga Cab",
    "description": "For a comfortable and spacious ride, choose the Ertiga for your journey from Thane to Pune. Skyline Cabs provides well-maintained Ertiga vehicles, ideal for small families or group travel. Book your ride now for a smooth and affordable trip."
  },
  {
    "name": "Thane to Pune One Way Taxi",
    "description": "Skyline Cabs offers a convenient one-way taxi service from Thane to Pune. Enjoy comfort, convenience, and competitive pricing on your one-way journey. With easy online booking and reliable drivers, your trip will be smooth and enjoyable."
  },
  {
    "name": "Thane to Pimpri Chinchwad Cab Fare",
    "description": "Skyline Cabs provides affordable and transparent taxi fares for trips from Thane to Pimpri Chinchwad. Whether you're traveling for business or personal reasons, our fleet of well-maintained vehicles will ensure your journey is comfortable and hassle-free."
  },
  {
    "name": "Thane to Pune Cab Service",
    "description": "For a dependable and affordable taxi service from Thane to Pune, Skyline Cabs is your go-to choice. With a variety of vehicle options, including sedans, SUVs, and luxury cars, we ensure a safe and comfortable journey at the best prices."
  },
  {
    "name": "Thane to Pune Innova Cab Service",
    "description": "Skyline Cabs offers Innova cab services for your journey from Thane to Pune. Ideal for families or groups, our Innova cabs provide comfort and ample space for luggage. With experienced drivers and competitive pricing, your trip will be smooth and worry-free."
  },
  {
    "name": "Mulund to Pune Taxi Fare",
    "description": "Skyline Cabs offers transparent and competitive taxi fares for journeys from Mulund to Pune. Whether you're traveling alone or with a group, our fleet of well-maintained vehicles ensures a safe and comfortable ride at the best prices."
  },
  {
    "name": "Cab Service in Thane",
    "description": "Skyline Cabs offers reliable and affordable taxi services within Thane. Whether you need a local ride or an outstation trip, our fleet of vehicles and professional drivers ensure a comfortable and punctual service at all times."
  },
  {
    "name": "Thane to Pune Round Trip Cab Service",
    "description": "Book a round-trip cab service from Thane to Pune with Skyline Cabs. We offer flexible timings and vehicle options to meet your needs, ensuring a comfortable and reliable experience for both legs of your journey."
  },
  {
    "name": "Thane to Baner Cab Fare",
    "description": "Traveling from Thane to Baner? Skyline Cabs offers affordable and reliable taxi services with transparent pricing. Our fleet of well-maintained vehicles, along with experienced drivers, ensures a smooth journey to your destination."
  },
  {
    "name": "Outstation Taxi Service in Thane",
    "description": "Skyline Cabs provides top-notch outstation taxi services in Thane. Whether you're traveling to Pune, Lonavala, or other destinations, we offer reliable and affordable services with a fleet of comfortable vehicles and experienced drivers."
  },
  {
    "name": "Best Outstation Taxi Service in Thane",
    "description": "Skyline Cabs is proud to offer the best outstation taxi services in Thane. With a focus on comfort, safety, and reliability, we ensure that your journey is smooth and hassle-free. Our well-maintained vehicles and professional drivers are ready for your next trip."
  },
  {
    "name": "Best Outstation Taxi Service in Thane Contact Number",
    "description": "To book the best outstation taxi service in Thane, contact Skyline Cabs at [Insert Contact Number]. Our team is available to assist with bookings, answer queries, and ensure your trip is comfortable and punctual."
  },
  {
    "name": "Best Outstation Cab Service in Mumbai",
    "description": "Skyline Cabs offers the best outstation cab services in Mumbai, including services from Thane to Pune and other destinations. Our fleet includes a variety of vehicles, ensuring you have the best ride for your journey. With affordable rates and excellent service, Skyline Cabs is your trusted partner."
  },
  {
    "name": "Taxi Service in Thane West",
    "description": "Skyline Cabs provides excellent taxi services in Thane West. Whether you need a local ride or are heading outstation, we offer a range of vehicle options that ensure comfort, affordability, and punctuality for all your travel needs."
  },
  {
    "name": "Outstation Taxi Service in Thane",
    "description": "Looking for reliable outstation taxi services in Thane? Skyline Cabs provides affordable, comfortable, and safe rides to destinations across Maharashtra and beyond. Book your outstation taxi service today for a hassle-free trip."
  }
],
"tableData": [
  ["Thane to Pune Cab", "Thane to Pune Taxi"],
  ["Thane to Pune Station Cab Fare", "Thane to Pune One Way Cab"],
  ["Thane to Pune Ertiga Cab", "Thane to Pune One Way Taxi"],
  ["Thane to Pimpri Chinchwad Cab Fare", "Thane to Pune Cab Service"],
  ["Thane to Pune Innova Cab Service", "Mulund to Pune Taxi Fare"],
  ["Mulund to Pune Taxi Fare", "Cab Service in Thane"],
  ["Thane to Pune Round Trip Cab Service", "Thane to Baner Cab Fare"],
  ["Outstation Taxi Service in Thane", "Best Outstation Taxi Service in Thane"],
  ["Best Outstation Taxi Service in Thane Contact Number", "Best Outstation Cab Service in Mumbai"],
  ["Taxi Service in Thane West", "Outstation Taxi Service in Thane"]
],



whychoose: [
    {
        "WhyChooseheading": "Reliable Thane to Pune Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers dependable and punctual cab services from Thane to Pune. Whether you're traveling for business, leisure, or any other reason, we ensure a comfortable and timely journey every time."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
        "WhyChoosedescription": "Our fleet includes well-maintained vehicles, from sedans to spacious SUVs, all designed to provide a comfortable and relaxing ride. Every vehicle is air-conditioned, ensuring that you enjoy your journey from Thane to Pune in comfort."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are highly experienced and well-versed with the best routes from Thane to Pune. They ensure your safety, comfort, and punctuality, making your journey smooth and stress-free."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "With Skyline Cabs, you’ll always know the cost upfront. We offer competitive pricing with no hidden charges, ensuring that you get great value for your money on your Thane to Pune trip."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Convenience",
        "WhyChoosedescription": "We operate 24/7, so you can book a ride from Thane to Pune at any time, day or night. Whether you need an early morning ride or a late-night departure, we’re always ready to assist you."
    },
    {
        "WhyChooseheading": "Easy and Quick Online Booking",
        "WhyChoosedescription": "Booking your cab is fast and easy with Skyline Cabs. Simply use our website or mobile app to book your ride in minutes, and enjoy instant booking confirmation along with real-time tracking for your convenience."
    },
    {
        "WhyChooseheading": "Safe and Sanitized Vehicles",
        "WhyChoosedescription": "Your safety and well-being are our top priorities. All of our vehicles are thoroughly sanitized before each ride, and our drivers follow strict hygiene protocols, ensuring that you travel in a clean, safe, and hygienic environment."
    },
    {
        "WhyChooseheading": "Variety of Vehicles to Suit Your Needs",
        "WhyChoosedescription": "Skyline Cabs offers a variety of vehicles to suit all group sizes. Whether you’re traveling solo, with family, or in a group, we have the perfect vehicle for your journey from Thane to Pune, ensuring comfort for everyone."
    }
]




















    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Thane to Pune with Skyline Cabs?',
            answer:
                'Booking a cab from Thane to Pune is simple and convenient. You can book via our website, mobile app, or by calling our customer support. Just provide your pickup and drop-off details, select a vehicle, and confirm the booking.',
        },
        {
            id: 2,
            question: 'What types of vehicles are available for the Thane to Pune trip?',
            answer:
                'Skyline Cabs offers a wide range of vehicles including Sedans, SUVs, Ertiga, Innova Crysta, and premium cars. Choose based on your group size and comfort preference.',
        },
        {
            id: 3,
            question: 'How long does it take to travel from Thane to Pune?',
            answer:
                'The travel time from Thane to Pune is typically around 3.5 to 5 hours, depending on traffic. Our expert drivers ensure a smooth and efficient journey.',
        },
        {
            id: 4,
            question: 'Are the cab fares from Thane to Pune fixed?',
            answer:
                'Yes, Skyline Cabs offers fixed pricing for the Thane to Pune route. The fare includes all charges like tolls, taxes, and driver fees—no hidden costs.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip cab from Thane to Pune?',
            answer:
                'Yes, you can book a round-trip with Skyline Cabs. Just share your return details while booking and we’ll handle the rest to ensure a smooth journey both ways.',
        },
        {
            id: 6,
            question: 'Can I make changes to my Thane to Pune cab booking?',
            answer:
                'Yes, bookings can be modified or cancelled via our app, website, or customer support. We provide flexible options for your convenience.',
        },
        {
            id: 7,
            question: 'Are the cabs for Thane to Pune well-maintained?',
            answer:
                'Absolutely! All our vehicles undergo regular maintenance and cleaning. We ensure every ride is comfortable, clean, and safe.',
        },
        {
            id: 8,
            question: 'What are the payment options for my Thane to Pune ride?',
            answer:
                'You can pay securely online using credit/debit cards, UPI, and net banking. We also accept cash payments at the end of the ride.',
        },
        {
            id: 9,
            question: 'Is Skyline Cabs suitable for corporate travel from Thane to Pune?',
            answer:
                'Yes, we offer specialized corporate travel services for professionals and teams. Contact us for business-friendly packages and reliable transport solutions.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for your Thane to Pune travel?',
            answer:
                'Skyline Cabs offers professional drivers, clean vehicles, transparent pricing, and exceptional service. We’re committed to making your Thane to Pune trip smooth and stress-free.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ramesh Verma",
            rating: 5,
            review: "I booked a cab from Thane to Pune with Skyline and it was excellent. The vehicle was clean and comfortable, and the driver was courteous. Highly recommended!"
        },
        {
            name: "Miss. Sonal Gupta",
            rating: 4,
            review: "Great ride from Thane to Pune. The car was nice and the journey was smooth. Would've liked a faster pickup, but overall, very good service."
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Thane to Pune Cab",
  "image": "https://skylinecabs.com/assets/images/thane-to-pune-cab.jpg",
  "description": "Book Thane to Pune cab with Skyline Cabs for a smooth, affordable, and comfortable journey. Choose from AC sedans, SUVs, or premium cars—available 24/7 with verified drivers for one-way and round-trip rides.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7523"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1400",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/thane-to-pune-cab"
  }
};


      
     
      


    return (
        <div>

<Helmet>
  <title>Thane to Pune Cab | AC Taxi Booking 24/7 | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Thane to Pune cab with Skyline Cabs for a smooth, affordable, and comfortable journey. Choose from AC sedans, SUVs, or premium cars—available 24/7 with verified drivers for one-way and round-trip rides." 
  />
  <meta 
    name="keywords" 
    content="Thane to Pune Cab, Cab from Thane to Pune, One-Way Taxi Thane to Pune, Round Trip Cab Thane to Pune, AC Cab Thane to Pune, SUV Taxi Thane to Pune, Affordable Taxi Thane to Pune, Skyline Cabs Thane to Pune, Online Cab Booking Thane to Pune, 24/7 Taxi Thane to Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/52.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Thanetopunecab;